<template>
  <div v-if="coupon" class="coupon-container">
    <template v-if="2 === coupon.userType">
      <span class="black-type">黑金券</span>
      <span class="black-title">{{ coupon.title }}</span>
    </template>
    <template v-else>
      <span class="p-type">券</span>
      <span class="title">{{ coupon.title }}</span>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    coupon: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
.coupon-container {
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
}
.black-type {
  font-size: rem(20px);
  color: #f6e0ca;
  display: inline-flex;
  align-items: center;
  height: rem(28px);
  border: 1px solid #624e4e;
  padding: 0 rem(8px);
  background-image: linear-gradient(270deg, #443f3f 0%, #624e4e 100%),
    linear-gradient(270deg, #624e4e 0%, #443f3f 100%);
  border-radius: rem(4px) 0px 0px rem(4px);
}
.black-title {
  font-size: rem(20px);
  color: #464040;
  display: inline-flex;
  align-items: center;
  height: rem(28px);
  padding: 0 rem(8px);
  border: 1px solid #f4dbc3;
  background: #f4dbc3;
  border-radius: 0px rem(4px) rem(4px) 0px;
}

.p-type {
  display: inline-flex;
  height: rem(28px);
  font-size: rem(20px);
  color: #ffffff;
  align-items: center;
  border-bottom-left-radius: rem(4px);
  border-top-left-radius: rem(4px);
  border: 1px solid rgba(255, 136, 0, 1);
  background-color: #ff8800;
  padding: 0 rem(8px);
}
.title {
  font-size: rem(20px);
  display: inline-flex;
  color: #ff8800;
  align-items: center;
  border: 1px solid rgba(255, 136, 0, 1);
  padding: 0 rem(8px);
  border-bottom-right-radius: rem(4px);
  border-top-right-radius: rem(4px);
  height: rem(28px);
}
</style>
